import React from 'react';
import { trackLink } from '@vfit/shared/data-access';
import { useDeviceType } from '@vfit/shared/hooks';
import { Button, ImageAtoms } from '@vfit/shared/atoms';
import { IDownloadCard } from '@vfit/shared/models';
import { checkIsApp } from '@vfit/consumer/data-access';
import {
  Container,
  CtaContainer,
  Description,
  HeadText,
  ImageContainer,
  InnerContainer,
  QRCodeImg,
  QRContainer,
  QRDescription,
  QRTitle,
  Title,
  TopImageContainer,
  DivImgContainer,
} from './downloadCard.style';

const DownloadCard: React.FC<IDownloadCard> = ({ dataContent, apps }) => {
  const { isDesktop, isMobile } = useDeviceType();
  const { buttonCard, qrCodeCard } = dataContent;

  function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform);
  }

  const downloadApp = () => {
    if (!apps || apps.length === 0) return;
    const androidApp = apps.find((app) => app.url?.includes('play.google'));
    const iosApp = apps.find((app) => app.url?.includes('itunes.apple'));
    const userAgent = navigator.userAgent || navigator.vendor;
    if (userAgent && (androidApp || iosApp)) {
      if (/android/i.test(userAgent)) {
        window.open(androidApp?.url || '', '_blank');
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && iOS()) {
        window.open(iosApp?.url || '', '_blank');
      }
      trackLink(buttonCard.ctaLabel);
    }
  };

  if (!isDesktop) {
    return (
      <Container>
        <TopImageContainer>
          <DivImgContainer absolute>
            <ImageAtoms
              nameCard="downloadCard"
              image={buttonCard.heroImg}
              imageMobile={buttonCard.hermoImgMobile}
              isMobile
            />
          </DivImgContainer>
          <ImageContainer>
            <ImageAtoms
              nameCard="buttonCard"
              image={buttonCard.backHeroImg}
              imageMobile={buttonCard.backHeroImgMobile}
              isMobile={isMobile}
              width="327px"
            />
          </ImageContainer>
        </TopImageContainer>
        <InnerContainer>
          <Title>{buttonCard.title}</Title>
          <Description>{buttonCard.description}</Description>
          <CtaContainer>
            <Button
              variant={checkIsApp() ? 'mva:primary' : 'primary'}
              onClick={downloadApp}
              name="action_download"
              title={buttonCard.ctaLabel}
            >
              {buttonCard.ctaLabel || ''}
            </Button>
          </CtaContainer>
        </InnerContainer>
      </Container>
    );
  }
  return (
    <QRContainer>
      <QRCodeImg>
        <ImageAtoms nameCard="qrcodeimg" image={qrCodeCard.qrCodeImg} />
      </QRCodeImg>
      <HeadText>{qrCodeCard.secondaryTitle}</HeadText>
      <QRTitle>{qrCodeCard.primaryTitle}</QRTitle>
      <QRDescription>{qrCodeCard.description}</QRDescription>
    </QRContainer>
  );
};
export default DownloadCard;

